import { gql, useMutation, useQuery } from "@apollo/client";
import {
  CreateSyllableFromPosition,
  CreateSyllableFromPositionVariables,
} from "./__generated__/CreateSyllableFromPosition";
import {
  DeleteSyllableFromPosition,
  DeleteSyllableFromPositionVariables,
} from "./__generated__/DeleteSyllableFromPosition";
import {
  ExtractSyllablesWithRegex,
  ExtractSyllablesWithRegexVariables,
} from "./__generated__/ExtractSyllablesWithRegex";

export const useCreateSyllableFromPosition = () =>
  useMutation<CreateSyllableFromPosition, CreateSyllableFromPositionVariables>(
    gql`
      mutation CreateSyllableFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        createSyllableFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `,
  );

export const useDeleteSyllableFromPosition = () =>
  useMutation<DeleteSyllableFromPosition, DeleteSyllableFromPositionVariables>(
    gql`
      mutation DeleteSyllableFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        deleteSyllableFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `,
  );

// GraphQL query for extracting syllables with regex
export const EXTRACT_SYLLABLES_WITH_REGEX = gql`
  query ExtractSyllablesWithRegex($projectId: UUID!, $pattern: String!, $caseSensitive: Boolean!) {
    extractSyllablesWithRegex(
      projectId: $projectId
      pattern: $pattern
      caseSensitive: $caseSensitive
    ) {
      startUtf16
      endUtf16
      text
      context
      contextStartUtf16
      removeSyllable
    }
  }
`;

// Hook to use the syllable extraction query
export function useExtractSyllablesWithRegex(
  { projectId, pattern, caseSensitive }: ExtractSyllablesWithRegexVariables,
  options: { skip?: boolean } = {},
) {
  return useQuery<ExtractSyllablesWithRegex, ExtractSyllablesWithRegexVariables>(
    EXTRACT_SYLLABLES_WITH_REGEX,
    {
      variables: {
        projectId,
        pattern,
        caseSensitive,
      },
      // Skip the query if pattern is empty
      skip: options.skip || !pattern || !projectId,
      // Fetch policy - adjust as needed
      fetchPolicy: "network-only",
    },
  );
}
